import type { UserDataSlice } from './user.type'

export const userInitialState: UserDataSlice = {
  currentUser: null,
  invitations: [],
  loading: false,
  error: null,
}
